import script from "./PopupAdverst.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupAdverst.vue?vue&type=script&setup=true&lang=ts"

import "./PopupAdverst.vue?vue&type=style&index=0&id=f268a068&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f268a068"]])

export default __exports__